/**
 * DevExtreme (esm/renovation/ui/pager/common/keyboard_action_context.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    createContext
} from "@devextreme/runtime/inferno";
export var KeyboardActionContext = createContext(void 0);
